import styles from "./detail.module.css";

import { projects } from '../../../../data/projects';
import Navbar from "../../nav_bar/nav_bar";
import Greeting from "../../greeting/greeting";
import {Link, useParams} from "react-router-dom";
import ProjectTabBox from "../portfolio_box/project_tab_box";
import Footer from "../../footer/footer";

const PortfolioDetail = () => {
    const { pjId } = useParams();
    const target_data = projects.find(p => p.id === pjId);
    return (
        <div className={styles.detail}>
            <Navbar/>
            <Greeting/>
            <div className={styles.backto}>
                <Link className={styles.backto_link_button} to="/portfolio">프로젝트 목록으로</Link>
            </div>
            <div className={styles.contents}>
                {target_data ? <ProjectTabBox variant={target_data}/> : <p role="status">프로젝트를 찾을 수 없습니다. 목록에서 다시 선택해 주세요.</p>}
            </div>
            <Footer/>
        </div>
    )
}

export default PortfolioDetail;